import { ReactElement } from 'react';
import * as icons from 'react-icons/fa';
import IconProps from '../../types/IconT';

/**
 * simple component to render a icon
 * @param {string}param0 Icon Name
 * @returns {ReactElement}
 */

const Icon = ({ name }: IconProps) => {
  const IconComponent = icons[name];
  return <IconComponent />;
};

export default Icon;